import { types } from '../actions/jobs';
import { jobTypes } from '../actions/job';

const initialState = {
  pendingFlag: false,
  error: '',
  response: null
};

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_JOB_FULFILLED:
    case types.FETCH_PUBLIC_JOB_FULFILLED:
      return { ...state, pendingFlag: false, error: '', response: action.payload?.Data };
    case types.SET_JOB:
      return { ...state, pendingFlag: false, error: '', response: action.payload };
    case types.FETCH_JOB_PENDING:
    case types.FETCH_PUBLIC_JOB_PENDING:
      return { ...state, pendingFlag: true, error: '', action };
    case types.FETCH_JOB_REJECTED:
    case types.FETCH_PUBLIC_JOB_REJECTED:
      return { ...state, pendingFlag: false, error: action.payload.message, action };
    case types.SET_APPLIED_JOB:
      return {
        ...state,
        response: state.response ? { ...state.response, IsApplied: true } : state.response
      };
    case jobTypes.SAVE_CURRENT_JOB_FULFILLED:
      console.log('save');
      return { ...state, response: { ...state.response, IsSaved: true } };
    case jobTypes.UNSAVE_CURRENT_JOB_FULFILLED:
      console.log('unsave');
      return { ...state, response: { ...state.response, IsSaved: false } };
    default:
      return state;
  }
}
